
/*
 * This file is part of perse/engeno-ui.
 *
 * (c) per se <http://www.perse-beratung.de/>
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 *
 * This project is provided in good faith and hope to be usable by anyone.
 *
 * Author: Christian Schiffler <c.schiffler@cyberspectrum.de>
 *         Bernd Gauss <gauss.b@ub-gauss.de>
 */

import moment from 'moment'

export function formatDate (value) {
  if (value) {
    return moment(String(value)).format('DD.MM.YYYY')
  }
}
export function formatDateTime (value) {
  if (value) {
    return moment(String(value)).format('DD.MM.YYYY HH:mm:ss')
  }
}
/* n: Value, c: Nachkomma, d: Dezimaltrenner   t: Tausendertrenner          */
export function formatter (n, c, d, t) {
  c = isNaN(c = Math.abs(c)) ? 2 : c
  d = d === undefined ? ',' : d
  t = t === undefined ? '.' : t
  const s = n < 0 ? '-' : ''
  const i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c)))
  let j
  j = (j = i.length) > 3 ? j % 3 : 0
  return s + (j ? i.substr(0, j) + t : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : '')
}

export function formatMoney (value, showZero) {
  return formatNumber(value, {showZero, suffix: '€'})
}

export function formatTax (value, showZero) {
  let newVal = Math.trunc(value * 100) / 100
  return formatNumber(newVal, {showZero, suffix: '€'})
}

export function formatNumber (value, configuration) {
  configuration = configuration || {}
  if (value || configuration.showZero) {
    return formatter(value, configuration.decimals !== undefined ? configuration.decimals : 2) + (configuration.suffix || '')
  }
}

export function formatText (value) {
  return value.replace(/(?:\r\n|\r|\n)/g, '<br>')
}

export function timeDifference(current, previous) {
  const msPerMinute = 60 * 1000;
  const msPerHour = msPerMinute * 60;
  const msPerDay = msPerHour * 24;
  const msPerMonth = msPerDay * 30;
  const msPerYear = msPerDay * 365;
  const elapsed = current - previous;
  if (elapsed < msPerMinute) {
    const seconds = Math.round(elapsed/1000)
    return {type: 'seconds', seconds}
  }
  if (elapsed < msPerHour) {
    const minutes = Math.round(elapsed/msPerMinute)
    return {type: 'minutes', minutes}
  }
  if (elapsed < msPerDay ) {
    const hours = Math.round(elapsed/msPerHour)
    return {type: 'hours', hours}
  }
  if (elapsed < msPerMonth) {
    const days = Math.round(elapsed/msPerDay)
    return {type: 'days', days}
  }
  if (elapsed < msPerYear) {
    const months = Math.round(elapsed/msPerMonth)
    return {type: 'months', months}
  }

  const years = Math.round(elapsed/msPerYear)
  return {type: 'years', years}
}

export function timeAgo (previous) {
  return timeDifference(new Date(), previous)
}
